function importAll (r) {
  r.keys().forEach(r);
}

window.$ = $
window.jQuery = $
import 'jquery.scrollto'
console.log('asd')
import Rails from "@rails/ujs"
Rails.start()

import 'slick-carousel'
import 'slick-carousel/slick/slick.css'
import 'jquery-colorbox'

importAll(require.context('lum2021/images', true))
import 'normalize.css'
import 'lum2021/styles/lum2021.sass'
import 'scrolldepth/jquery.scrolldepth.min.js'